import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const commonService = {
  countries: params => axios.get(Pathes.Common.countries + getQuery(params)),
  faq: params => axios.get(Pathes.Help.miniFaqs + getQuery(params)),
  decisionWidget: params =>
    axios.get(Pathes.Common.decisionWidget + getQuery(params)),
  uploadFile: (file, onProgress) => {
    const formData = file instanceof FormData ? file : new FormData();
    if (!(file instanceof FormData)) formData.append('file', file);

    return axios.post(Pathes.Common.file, formData, {
      onUploadProgress: ({ loaded, total }) => {
        if (total && onProgress) onProgress(Math.round((loaded * 100) / total));
      },
    });
  },
};
